import { Paginate } from '@business/entities/common';
import { PurchaseOrderId } from '@business/entities/order';
import { R } from '@core/utils/r';
import { Endpoint } from '../endpoint';
import { CompactPurchaseOrderResponse, PurchaseOrderPageQuery, PurchaseOrderResponseAdditional } from './../../entities/order/PurchaseOrderResponse';

// export function fetchProducts() {
//   return Endpoint.get<OrderProductResponse[]>(`@gc/products`);
// }

export function fetchPurchaseOrders(params: PurchaseOrderPageQuery) {
  return Endpoint.get<Paginate<CompactPurchaseOrderResponse, PurchaseOrderResponseAdditional>>(`@gc/purchase-orders`, {
    params: R.objectCompact(params),
  });
}

export function fetchPurchaseOrder(id: PurchaseOrderId) {
  return Endpoint.get<CompactPurchaseOrderResponse>(`@gc/purchase-orders/purchase-order/${id}`);
}

export function updatePoStatus(id: PurchaseOrderId, status: string) {
  return Endpoint.post<CompactPurchaseOrderResponse>(`@gc/purchase-orders/status/${id}`, { data: { status } });
}
